/**
 * StatsCards - Dashboard statistics cards for Stock Rebalancer
 */
import React from "react";
import { Card } from "@/components/ui/card";
import { Building2, Warehouse, TrendingDown, Lightbulb } from "lucide-react";

export default function StatsCards({ stats, defaultSettings }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-3" data-testid="rebalancer-stats">
      <Card className="p-3">
        <div className="text-xs text-muted-foreground">Custom Thresholds</div>
        <div className="text-2xl font-semibold">{stats.products_with_custom_thresholds || 0}</div>
        <div className="text-xs text-muted-foreground">of {stats.total_products} products</div>
      </Card>
      <Card className="p-3">
        <div className="text-xs text-muted-foreground flex items-center gap-1">
          <Building2 className="w-3 h-3 text-slate-500" /> Normal Shops
        </div>
        <div className="text-2xl font-semibold">{stats.shop_counts?.normal || 0}</div>
        <div className="text-xs text-muted-foreground">min: {defaultSettings.normal_min_qty}, max: {defaultSettings.normal_max_qty}</div>
      </Card>
      <Card className="p-3">
        <div className="text-xs text-muted-foreground flex items-center gap-1">
          <Warehouse className="w-3 h-3 text-blue-500" /> Warehouses
        </div>
        <div className="text-2xl font-semibold text-blue-600">{stats.shop_counts?.warehouse || 0}</div>
        <div className="text-xs text-muted-foreground">min: {defaultSettings.warehouse_min_qty}, max: {defaultSettings.warehouse_max_qty}</div>
      </Card>
      <Card className="p-3">
        <div className="text-xs text-muted-foreground flex items-center gap-1">
          <TrendingDown className="w-3 h-3 text-red-500" /> Low Stock
        </div>
        <div className="text-2xl font-semibold text-red-600">{stats.status_counts?.low_stock || 0}</div>
      </Card>
      <Card className="p-3">
        <div className="text-xs text-muted-foreground flex items-center gap-1">
          <Lightbulb className="w-3 h-3 text-purple-500" /> Imbalanced
        </div>
        <div className="text-2xl font-semibold text-purple-600">{stats.status_counts?.imbalanced || 0}</div>
      </Card>
    </div>
  );
}
